(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-capsule-comparison"] && !Shopify.designMode) return;
  try {
    
function initCapsComparison(scope=document){
 scope.querySelectorAll('[data-caps-compare]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.querySelector('.cc-filters').hidden=false;
  root.querySelectorAll('[data-cc-filter]').forEach(button=>button.addEventListener('click',()=>{
   const filter=button.dataset.ccFilter;
   root.querySelectorAll('[data-cc-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   root.querySelectorAll('[data-cc-cell]').forEach(cell=>{cell.hidden=!(filter==='all'||cell.dataset.material===filter||(filter==='decaf'&&cell.dataset.decaf==='true'));});
   root.querySelector('.cc-scroll').scrollLeft=0;
  }));
 });
}
initCapsComparison();
document.addEventListener('shopify:section:load',event=>initCapsComparison(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-capsule-hero-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mood-capsule-slider')) {
  customElements.define('mood-capsule-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('.mch-viewport');
      this.track = this.querySelector('.mch-track');
      this.slides = Array.from(this.querySelectorAll('.mch-slide'));
      this.dots = Array.from(this.querySelectorAll('[data-index]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      this.wide = matchMedia('(min-width: 990px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.querySelector('.mch-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true), options));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.focused = false;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, options);
      this.viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.pointerType === 'pen') this.touch = { x: event.clientX, y: event.clientY };
      }, options);
      this.viewport.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.swipedUntil = Date.now() + 500;
          this.show(this.index + (dx < 0 ? 1 : -1), true);
        }
      }, options);
      this.viewport.addEventListener('pointercancel', () => { this.touch = null; }, options);
      this.viewport.addEventListener('click', event => {
        if (Date.now() < (this.swipedUntil || 0)) { event.preventDefault(); event.stopPropagation(); this.swipedUntil = 0; }
      }, { ...options, capture: true });
      this.resize = new ResizeObserver(() => this.measure());
      this.slides.forEach(slide => this.resize.observe(slide));
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.35 });
      this.intersection.observe(this);
      const responsiveChange = () => { this.measure(); this.updateToggle(); this.schedule(); };
      this.wide.addEventListener('change', responsiveChange, options);
      this.reduced.addEventListener('change', responsiveChange, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.show(0, false);
    }
    show(index, manual) {
      this.index = (index + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== this.index));
        slide.inert = i !== this.index;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (manual) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      this.measure();
      this.updateToggle();
      this.schedule();
    }
    measure() {
      const heights = this.slides.map(slide => slide.offsetHeight);
      this.viewport.style.height = `${this.wide.matches ? Math.max(...heights) : heights[this.index]}px`;
    }
    updateToggle() {
      this.toggle.hidden = this.dataset.autoplay !== 'true' || !this.wide.matches || this.reduced.matches;
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || !this.visible || document.hidden || !this.wide.matches || this.reduced.matches) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-corporate-coffee"] && !Shopify.designMode) return;
  try {
    
function initCorporate(root){if(root.dataset.mccReady)return;root.dataset.mccReady='true';root.querySelectorAll('[data-mcc-interest]').forEach(function(link){link.addEventListener('click',function(){var select=root.querySelector('[data-mcc-interest-select]');if(select){select.value=link.dataset.mccInterest;select.dispatchEvent(new Event('change',{bubbles:true}));}});});}document.querySelectorAll('[data-mcc]').forEach(initCorporate);document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-mcc]').forEach(initCorporate);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-machine-catalog"] && !Shopify.designMode) return;
  try {
    
function initMoodMachineCatalog(scope=document){scope.querySelectorAll('.mood-machines').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const groups=[...root.querySelectorAll('[data-machine-brand]')],select=root.querySelector('[data-machine-select]'),nav=root.querySelector('[data-machine-buttons]'),status=root.querySelector('[data-machine-status]');groups.forEach(group=>{const name=group.querySelector('h2').textContent.trim(),key=group.dataset.machineBrand;const option=document.createElement('option');option.value=key;option.textContent=name;select.append(option);const button=document.createElement('button');button.type='button';button.dataset.machineFilter=key;button.textContent=name;button.setAttribute('aria-pressed','false');nav.append(button)});function filter(value){if(value!=='all'&&!groups.some(g=>g.dataset.machineBrand===value))value='all';select.value=value;groups.forEach(group=>group.hidden=value!=='all'&&group.dataset.machineBrand!==value);nav.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.machineFilter===value)));status.textContent=groups.filter(g=>!g.hidden).map(g=>g.querySelector('h2').textContent.trim()+' ('+g.dataset.machineCount+')').join(' · ')}nav.addEventListener('click',event=>{const b=event.target.closest('[data-machine-filter]');if(b)filter(b.dataset.machineFilter)});select.addEventListener('change',()=>filter(select.value));filter('all')})}initMoodMachineCatalog();document.addEventListener('shopify:section:load',event=>initMoodMachineCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-private-label"]) return;
  try {
    

document.querySelectorAll('.mpl').forEach(function(root){
 if(root.dataset.mplReady)return;
 root.dataset.mplReady='true';
 root.querySelectorAll('[data-mpl-format]').forEach(function(link){
  link.addEventListener('click',function(){
   var values={beans:'Coffee beans / ground coffee',capsules:'Coffee capsules',drip:'Drip coffee bags'};
   var select=root.querySelector('select[name="contact[Product format]"]');
   if(select){select.value=values[link.dataset.mplFormat]||'';select.dispatchEvent(new Event('change',{bubbles:true}));}
  });
 });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-retail-mh"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-retail-success]').forEach(function(el){el.focus();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-roastery-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialize = (root) => {
      root.querySelectorAll('[data-mood-facility-hero] video').forEach((video) => {
        if (video.dataset.moodReady) return;
        video.dataset.moodReady = 'true';
        video.muted = true;
        video.playsInline = true;
        const syncMotion = () => {
          video.autoplay = !motion.matches;
          if (motion.matches) video.pause();
          else video.play().catch(() => {});
        };
        syncMotion();
        motion.addEventListener('change', syncMotion);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mood-gallery')) {
  customElements.define('mood-gallery', class MoodGallery extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
      if (!this.panels.length) return;
      this.index = Math.max(0, this.panels.findIndex(panel => !panel.hidden));
      this.controls = this.querySelector('[data-gallery-controls]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.status = this.querySelector('[data-gallery-status]');
      this.pauseButton = this.querySelector('[data-gallery-pause]');
      this.pauseText = this.querySelector('[data-gallery-pause-text]');
      this.autoEnabled = this.dataset.autorotate === 'true';
      this.interval = Math.max(2000, Number(this.dataset.interval) || 7000);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = !this.autoEnabled || this.motionQuery.matches;
      this.focusPaused = this.contains(document.activeElement);
      this.hoverPaused = false;
      this.editorPaused = false;
      this.viewportPaused = 'IntersectionObserver' in window;
      if (this.viewportPaused) {
        const observer = new window.IntersectionObserver(entries => {
          if (!this.isConnected || this.visibilityObserver !== observer) return;
          const entry = entries.find(item => item.target === this);
          if (!entry) return;
          this.viewportPaused = !entry.isIntersecting;
          this.schedule();
        });
        this.visibilityObserver = observer;
        observer.observe(this);
      }
      const on = (target, name, listener) => target?.addEventListener(name, listener, { signal: this.abortController.signal });
      on(this.querySelector('[data-gallery-previous]'), 'click', () => this.show(this.index - 1, { announce: true, manual: true }));
      on(this.querySelector('[data-gallery-next]'), 'click', () => this.show(this.index + 1, { announce: true, manual: true }));
      on(this.pauseButton, 'click', () => {
        this.userPaused = !this.userPaused;
        if (!this.userPaused) {
          this.focusPaused = false;
          this.hoverPaused = false;
        }
        this.updatePauseLabel();
        this.schedule();
      });
      on(this, 'focusin', () => { this.focusPaused = true; this.schedule(); });
      on(this, 'focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        this.focusPaused = this.contains(document.activeElement);
        this.schedule();
      }));
      on(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
          this.hoverPaused = true;
          this.schedule();
        }
      });
      on(this, 'pointerleave', () => { this.hoverPaused = false; this.schedule(); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motionQuery, 'change', () => {
        if (this.motionQuery.matches) this.userPaused = true;
        this.updatePauseLabel();
        this.schedule();
      });
      on(document, 'shopify:block:select', event => {
        const selected = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (selected < 0) return;
        this.editorPaused = true;
        this.show(selected);
      });
      on(document, 'shopify:block:deselect', event => {
        if (!this.panels.some(panel => panel.dataset.blockId === event.detail?.blockId)) return;
        this.editorPaused = false;
        this.schedule();
      });
      this.suppressSwipeClickUntil = 0;
      this.addEventListener('click', event => {
        if (event.detail === 0 || Date.now() > this.suppressSwipeClickUntil || !event.target.closest('.mood-gallery__media')) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressSwipeClickUntil = 0;
      }, { capture: true, signal: this.abortController.signal });
      on(this, 'pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.target.closest('.mood-gallery__media')) return;
        this.suppressSwipeClickUntil = 0;
        this.swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      on(this, 'pointercancel', () => { this.swipeStart = null; });
      on(this, 'pointerup', event => {
        if (!this.swipeStart || this.swipeStart.id !== event.pointerId) return;
        const dx = event.clientX - this.swipeStart.x;
        const dy = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        this.suppressSwipeClickUntil = Date.now() + 600;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.show(this.index + (dx < 0 ? direction : -direction), { announce: true, manual: true });
      });
      if (this.controls) this.controls.hidden = this.panels.length < 2;
      if (this.pauseButton) this.pauseButton.hidden = !this.autoEnabled;
      this.dataset.enhanced = 'true';
      this.show(this.index);
    }
    disconnectedCallback() {
      this.clearTimer();
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.abortController?.abort();
      this.abortController = null;
      this.swipeStart = null;
    }
    clearTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    schedule() {
      this.clearTimer();
      if (!this.isConnected || !this.autoEnabled || this.userPaused || this.focusPaused || this.hoverPaused || this.editorPaused || this.viewportPaused || document.hidden || this.panels.length < 2) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), this.interval);
    }
    updatePauseLabel() {
      if (!this.pauseButton) return;
      const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-label', label);
      if (this.pauseText) this.pauseText.textContent = label;
    }
    show(index, options = {}) {
      if (!this.panels?.length) return;
      const next = (index % this.panels.length + this.panels.length) % this.panels.length;
      if (options.manual) this.userPaused = true;
      this.panels.forEach((panel, panelIndex) => {
        const selected = panelIndex === next;
        panel.hidden = !selected;
        panel.inert = !selected;
      });
      this.index = next;
      if (this.counter) this.counter.textContent = `${next + 1} / ${this.panels.length}`;
      if (this.status && options.announce) {
        this.status.textContent = (this.dataset.statusTemplate || '[current] / [total]').replace('[current]', next + 1).replace('[total]', this.panels.length);
      }
      this.updatePauseLabel();
      this.schedule();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
